import {
  PayloadAction,
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { Config } from "../../../config/Config";
import _ from "lodash";
import { RootState } from "../../../app/store";
import WellnessRepository from "../WellnessRepository";
import { Tenant } from "../../Tenant/TenantSlice";

export interface WellnessBodyView {
  id: number;
  name: string;
  image: string;
  imagemobile: string;
  price: number;
  city: string;
  isIndividual: boolean;
  tenant: string;
  remotelyOrPresenceEnum: string;
  typology: string;
}

export const getWellnessBodyViewAsync = createAsyncThunk(
  "wellnessBody/getWellnessBodyView",
  async (data: { queryString?: string }) => {
    console.log("📡 API chiamata con queryString:", data?.queryString);

    const wellNessRepository = new WellnessRepository();
    const response = await wellNessRepository.getWellnessBodyView(
      data?.queryString
    );

    console.log("🔍 Config path:", Config.WELLNESS_BODY_ACTIVITY_TAIL_RESPONSE);

    console.log("📡 API Finita con queryString:", data?.queryString);
    console.log("🔍 Response completa:", response);
    console.log("🔍 Response completa:", response.data?.[0]?.tenantId);

    const activityTails = _.get(
      response,
      Config.WELLNESS_BODY_ACTIVITY_TAIL_RESPONSE
    );

    console.log("📦 Dati restituiti:", {
      count: activityTails?.length || 0,
      data: activityTails,
    });

    return activityTails;
  }
);

const WellnessBodyViewAdapter = createEntityAdapter<WellnessBodyView>({
  selectId: (WellnessBodyView) => WellnessBodyView.id,
});

export const wellnessBodyViewSlice = createSlice({
  name: "wellnessBodyViews",
  initialState: WellnessBodyViewAdapter.getInitialState({
    status: "idle",
    reasonCode: "",
  }),
  reducers: {
    activityTailsEmptyState: (state) => {
      WellnessBodyViewAdapter.setAll(state, []);
      state.reasonCode = "";
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getWellnessBodyViewAsync.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          WellnessBodyViewAdapter.setAll(state, action.payload ?? []);
          state.status = "idle";
        }
      )
      .addCase(getWellnessBodyViewAsync.pending, (state: any) => {
        state.status = "loading";
      })
      .addCase(getWellnessBodyViewAsync.rejected, (state: any) => {
        state.status = "failed";
        state.reasonCode = "";
      });
  },
});

export const WellnessBodyViewSelector =
  WellnessBodyViewAdapter.getSelectors<RootState>(
    (state) => state.wellnessBodyViews
  );

export const { activityTailsEmptyState } = wellnessBodyViewSlice.actions;
export const selectWellnessBodyViewSliceStatus = (state: any) =>
  state.activityTails.status;
export const selectWellnessBodyViewSliceReasonCode = (state: any) =>
  state.activityTails.reasonCode;

//#endRegion Status

export default wellnessBodyViewSlice.reducer;
